import React from 'react';
import { Spinner as RadixSpinner, Flex } from '@radix-ui/themes';
import { theme } from '@planit.family/theme';

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

export interface SpinnerProps {
  size?: SpinnerSize;
  fullPage?: boolean;
  label?: string;
  className?: string;
}

const sizeMap: Record<SpinnerSize, '1' | '2' | '3'> = {
  sm: '1',
  md: '2',
  lg: '3',
  xl: '3',
};

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  fullPage = false,
  label = 'Loading…',
  className,
}) => {
  const spinner = (
    <RadixSpinner
      size={sizeMap[size]}
      className={className}
      aria-label={label}
    />
  );

  if (fullPage) {
    return (
      <Flex
        align="center"
        justify="center"
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: theme.zIndex.tooltip,
          background: 'rgba(255, 255, 255, 0.8)',
        }}
      >
        {spinner}
      </Flex>
    );
  }

  return spinner;
};

Spinner.displayName = 'Spinner';
